
<div class="modal-dialog confirm-dialog" style="display: flex; justify-content: center;">
  <div class="modal-content" style="min-width:630px;">
    <form #orderForm="ngForm">
      <div class="modal-body">
        <label>You have selected a Local to Central invoicing model. Please check that the Sold-To that has been selected for this project is in accordance with the documents received from customer. If it's not, please ask for correction to the initiator of the project.</label>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary" type="button" (click)="cancel()">OK</button>
      </div>
    </form>
  </div>
</div>